import { GetStaticPaths, GetStaticProps } from 'next'

import { EnsureAuthenticated, EnsureOrderIsLoaded } from 'components/ensurers'
import Layout from 'components/o_series/common/Layout'
import Test2 from 'components/o_series/2-test'

export const Test2Page = (): JSX.Element => {
  return (
    <EnsureAuthenticated>
      <EnsureOrderIsLoaded>
        <Test2 />
      </EnsureOrderIsLoaded>
    </EnsureAuthenticated>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  return { props: {} }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

Test2Page.Layout = Layout

export default Test2Page
